import React, { Component } from 'react';
import $ from 'jquery';
import config from "../config";

class ValidationBatchsModal extends Component{

    componentDidMount(){
        this.closeAction();
    }

    closeConfirm = async () => {
        const { SearchWhs, newOrderModel, refreshModel} = this.props;
        let user = await JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        $('#validationBatchsModal').modal('hide');
        let items = newOrderModel.Items || [];
        for (let index = 0; index < items.length; index++) {
            const item = items[index];
            if(SearchWhs.index === index && item.ItemCode ===  SearchWhs.itemCode){
                item.WhsCode = user.Branch.ProjectCode || null;
                item.whsSelected = true;
            }
        }
        $('#validationBatchsModal').modal('hide');  
        await refreshModel(newOrderModel);
    }

    closeAction = () => {
        $('#continvalidationBatchsModalueModal').on('hidden.bs.modal', function () {
        });
    };

    Continue = async ()=>{
        const {SearchAlmacen, SearchWhs, newOrderModel, refreshModel} = this.props;
        $('#validationBatchsModal').modal('hide');
        let items = newOrderModel.Items || [];
        for (let index = 0; index < items.length; index++) {
            const item = items[index];
            if(item.BatchNumbers && item.BatchNumbers.length > 0){
                item.BatchNumbers = [];
                item.DocUoMQty = Number(item.Quantity);
                item.OpenLneQty = Number(item.Quantity);
                item.SnBUoMQty = 0;
            }
        }
        await refreshModel(newOrderModel);
        await SearchAlmacen(SearchWhs.index, SearchWhs.warehouse, SearchWhs.itemCode)  
    }



    render() {
       
        return (
                <div className="modal" tabIndex="-1" role="dialog" id="validationBatchsModal" >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                        <div className="modal-body">
                            <p>Se han configurado lotes para este almacén si continúas se perderá la configuración. ¿Deseas continuar?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.Continue}> Si </button>
                            <button type="button" className="btn botonCorrect text-black" onClick={this.closeConfirm}>No</button>
                        </div>
                        </div>
                    </div>
                </div>
        );  
    }
}
export default ValidationBatchsModal;